import Glide from '@glidejs/glide';
import { autoBullets } from '../../../js/base/base-start';

/**
 * Blog Carousel
 */
(() => {
  const blogModule = document.querySelector('.module-blog');
  if (!blogModule) return;
  const blogData = document.querySelector('.js-blog-data');
  if (!blogData) return;
  const blogCarousel = blogModule.querySelector('.js-blog-carousel');
  blogData.querySelectorAll('article').forEach((post) => {
    blogCarousel.querySelector('.glide__slides').appendChild(post);
  });

  // glide setup
  const blogSlider = new Glide(blogCarousel, {
    type: 'carousel',
    autoplay: 5000,
    animationDuration: 500,
    animationTimingFunc: 'ease',
    startAt: 0,
    perView: 3,
    gap: 38,
    breakpoints: {
      1920: {
        perView: 3,
      },
      1400: {
        perView: 2,
      },
      991: {
        perView: 1,
      },
    },
  });

  // Fix tabindex on slides
  const updateTabindex = () => {
    const slides = Array.from(blogCarousel.querySelectorAll('.custom-blog-tile'));
    const activeSlideIndex = slides.findIndex((slide) => slide.classList.contains('glide__slide--active')); // Find the index of the active slide

    slides.forEach((slide, index) => {
      const elements = slide.querySelectorAll('.custom-blog-readmore');
      if (index >= activeSlideIndex && index < activeSlideIndex + blogSlider.settings.perView) {
        elements.forEach((element) => {
          element.setAttribute('tabindex', 0);
        });
      } else {
        elements.forEach((element) => {
          element.setAttribute('tabindex', -1);
        });
      }
    });
  };

  blogSlider.on('mounted', updateTabindex);

  blogSlider.on('run.after', updateTabindex);

  blogSlider.mount({
    AutoBullets: autoBullets,
  });
})();

/**
 * move newsletter into blog section
 */
(() => {
  const newsletterSource = document.querySelector('.blog-newsletter-source');
  const newsletterLocation = document.querySelector('.blog-newsletter .newsletter-location');
  if (!newsletterSource || !newsletterLocation) return;

  newsletterLocation.appendChild(newsletterSource);

  newsletterSource.querySelector('.subscribenewsletter').classList.remove('container');

  const buttons = newsletterSource.querySelectorAll('button:not(.subscr-close)');
  buttons.forEach((button) => {
    button.classList.add('nButton');
    button.textContent = 'Submit';
  });
})();
